// Module
var code = `<div class="panel-heading" role="tab" id="headingThree">
    <h4 class="panel-title">
        <a class="collapsed" role="button" data-toggle="collapse" data-parent="#accordion" aria-expanded="false" data-bind="attr:  { href: target }"
            aria-controls="collapseThree">
            <span data-bind="label: label"></span>
        </a>
    </h4>
</div>`;
// Exports
module.exports = code;